import { FC, useMemo } from "react";
import { AgreeIcon } from "shared/icons/AgreeIcon";
import { ExploreButtonFilled } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ExploreButton = styled(ExploreButtonFilled)`
    padding: 6px 12px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    max-width: 84px !important;
    min-width: 84px !important;
    width: 84px !important;
    height: 25px !important;
    margin-right: 0 !important;

    &:disabled {
        background-color: ${({ theme }) => theme.projectEdit.mobile.buttons.disabled.bg};
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.disabled.color} !important;
    }
`;


export enum IconStates {
    open = 'open',
    close = 'close',
    button = 'button'
}

const CloseIcon: FC = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.548618 0.404297C0.754347 0.198568 1.0879 0.198568 1.29363 0.404297L8.82311 7.93378L8.89357 7.86331L8.82311 7.93378C8.86999 7.98066 8.93358 8.007 8.99989 8.007C9.06619 8.007 9.12978 7.98066 9.17666 7.93378L9.1061 7.86321L9.17666 7.93378L16.7061 0.404298C16.9119 0.198568 17.2454 0.198568 17.4512 0.404298L17.5955 0.548619C17.8012 0.754348 17.8012 1.0879 17.5955 1.29363L10.066 8.82311L10.1367 8.89382L10.066 8.82311C10.0191 8.86999 9.99277 8.93358 9.99277 8.99989C9.99277 9.06619 10.0191 9.12978 10.066 9.17666L17.5955 16.7061C17.8024 16.9131 17.8007 17.2467 17.5951 17.4456C17.5268 17.5116 17.4893 17.5467 17.4677 17.566C17.2266 17.7827 16.893 17.7824 16.6919 17.5812L9.17666 10.066C9.07903 9.96836 8.92074 9.96836 8.82311 10.066L1.29364 17.5955C1.08667 17.8024 0.753017 17.8007 0.55421 17.5951C0.488131 17.5268 0.453119 17.4893 0.433765 17.4677C0.217026 17.2266 0.2174 16.893 0.41857 16.6919L7.93377 9.17666C7.98066 9.12978 8.007 9.06619 8.007 8.99989C8.007 8.93358 7.98066 8.86999 7.93378 8.82311L7.86306 8.89382L7.93378 8.82311L0.404297 1.29363C0.198568 1.0879 0.198568 0.754348 0.404297 0.548618L0.548618 0.404297Z" fill="#909090"/>
    </svg>
)

const Wrapper = styled.div`
    svg {
        width: 18px;
        height: 18px;
    }
`;

export const AgreeOrClose: FC<{ type: IconStates, enabled?: boolean }> = ({ type, enabled }) => {

    const Button = useMemo(() => (
        <ExploreButton disabled={!enabled}>Сохранить</ExploreButton>
    ), [enabled])

    const ICONS = {
        open: <AgreeIcon />,
        close: <CloseIcon />,
        button: Button
    }
    
    const icon = useMemo(() => ICONS[type] , [type, ICONS]);

    return (
        <Wrapper>
            {icon}
        </Wrapper>
    )
}import { FC, useMemo } from "react";
import { AgreeIcon } from "shared/icons/AgreeIcon";
import { ExploreButtonFilled } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ExploreButton = styled(ExploreButtonFilled)`
    padding: 6px 12px;
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    max-width: 84px !important;
    min-width: 84px !important;
    width: 84px !important;
    height: 25px !important;
    margin-right: 0 !important;

    &:disabled {
        background-color: ${({ theme }) => theme.projectEdit.mobile.buttons.disabled.bg};
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.disabled.color} !important;
    }
`;


export enum IconStates {
    open = 'open',
    close = 'close',
    button = 'button'
}

const CloseIcon: FC = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.548618 0.404297C0.754347 0.198568 1.0879 0.198568 1.29363 0.404297L8.82311 7.93378L8.89357 7.86331L8.82311 7.93378C8.86999 7.98066 8.93358 8.007 8.99989 8.007C9.06619 8.007 9.12978 7.98066 9.17666 7.93378L9.1061 7.86321L9.17666 7.93378L16.7061 0.404298C16.9119 0.198568 17.2454 0.198568 17.4512 0.404298L17.5955 0.548619C17.8012 0.754348 17.8012 1.0879 17.5955 1.29363L10.066 8.82311L10.1367 8.89382L10.066 8.82311C10.0191 8.86999 9.99277 8.93358 9.99277 8.99989C9.99277 9.06619 10.0191 9.12978 10.066 9.17666L17.5955 16.7061C17.8024 16.9131 17.8007 17.2467 17.5951 17.4456C17.5268 17.5116 17.4893 17.5467 17.4677 17.566C17.2266 17.7827 16.893 17.7824 16.6919 17.5812L9.17666 10.066C9.07903 9.96836 8.92074 9.96836 8.82311 10.066L1.29364 17.5955C1.08667 17.8024 0.753017 17.8007 0.55421 17.5951C0.488131 17.5268 0.453119 17.4893 0.433765 17.4677C0.217026 17.2266 0.2174 16.893 0.41857 16.6919L7.93377 9.17666C7.98066 9.12978 8.007 9.06619 8.007 8.99989C8.007 8.93358 7.98066 8.86999 7.93378 8.82311L7.86306 8.89382L7.93378 8.82311L0.404297 1.29363C0.198568 1.0879 0.198568 0.754348 0.404297 0.548618L0.548618 0.404297Z" fill="#909090"/>
    </svg>
)

const Wrapper = styled.div`
    svg {
        width: 18px;
        height: 18px;
    }
`;

export const AgreeOrClose: FC<{ type: IconStates, enabled?: boolean }> = ({ type, enabled }) => {

    const Button = useMemo(() => (
        <ExploreButton disabled={!enabled}>Сохранить</ExploreButton>
    ), [enabled])

    const ICONS = {
        open: <AgreeIcon />,
        close: <CloseIcon />,
        button: Button
    }
    
    const icon = useMemo(() => ICONS[type] , [type, ICONS]);

    return (
        <Wrapper>
            {icon}
        </Wrapper>
    )
}